// 用户信息
const userInfo = {};
 
export default {
    userInfo
};


// WEBPACK FOOTER //
// ./src/global/global.js